import styled from 'styled-components';

const Wrapper = styled.div<{ $link?: string; }>`
  text-align: center;
  justify-content: space-between;
  width: 33%;
  min-height: 350px;
  max-height: fit-content;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  padding: 0 16px 24px;
  cursor: ${(props) => (props.$link ? 'pointer' : 'default')};
  position: relative;

  h3 {
    margin: 0 auto;
    padding: 16px 0;
  }
  
  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }
`;

const DeviceImageWrapper = styled.img`
    height: 217px;
    pointer-events: none;
`;

const OverviewWrapper = styled.div`
  text-align: center;
  gap: 8px;
  font-size: 13px;
  padding-bottom: 15px; 

  img {
    height: 175px;
    width: 175px;
    padding: 20px;
    object-fit: cover;

    &.driver-img {
      border-radius: 100px;
    }

    &.vehicle-img {
      border-radius: 35px;
    }
  }

  .label {
    font-family: ManropeBold, sans-serif;
    margin-bottom: 5px;
  }
  
  .description {
    color: ${(props) => props.theme.colors.inactive}
  }
`;

export default { Wrapper, DeviceImageWrapper, OverviewWrapper };
